// extracted by mini-css-extract-plugin
module.exports = {"displayArea":"ShowArea_style_displayArea__OMcGb","content":"ShowArea_style_content__3IgF1"};